const LANGUAGE_CHECK_LENGTH = 300;
const LANGUAGE_CHECK_PERCENT = 0.5;
const CN_RANGE = [0x4e00, 0x9fa5];
const EN_RANGE = [0x21, 0x7e];

export function checkLanguage(input: string, checkOption?: Partial<{
    checkLength: number,
    checkPercent: number,
    cnRange: number[],
    enRange: number[]
}>): { isSupportLang: boolean, lang?: string } {
    if (input.length === 0) {
        return { isSupportLang: true };
    }

    const {
        checkLength = LANGUAGE_CHECK_LENGTH,
        checkPercent = LANGUAGE_CHECK_PERCENT,
        cnRange = CN_RANGE,
        enRange = EN_RANGE,
    } = checkOption || {};

    // 校验语言
    const inputStr = input.slice(0, checkLength);
    let cnCount = 0;
    let enCount = 0;
    let otherCount = 0;

    for (let i = 0; i < inputStr.length; i++) {
        const charCode = inputStr.charCodeAt(i);

        if (charCode >= cnRange[0] && charCode <= cnRange[1]) {
            cnCount++;
        } else if (
            charCode >= enRange[0] && charCode <= enRange[1]
        ) {
            enCount++;
        } else {
            otherCount++;
        }
    }

    const total = cnCount + enCount + otherCount;

    if (cnCount / total > checkPercent) {
        return { isSupportLang: true, lang: 'CN' };
    } else if (enCount / total > checkPercent) {
        return { isSupportLang: true, lang: 'EN' };
    } else {
        return { isSupportLang: false };
    }
}
